import React from 'react';
import './Componenst.css';
import BSModel from '../models/BSModel';
import SearchModel from '../models/SearchModel';
import loading from '../../img/loading.gif';
import { decryptAes, storeKey, encryptAes } from '../../crypto-utils';
import { ip } from './../../constants';
import Swal from 'sweetalert2/src/sweetalert2'
import '@sweetalert2/themes/dark/dark.css';
import { createBS, showError } from '../ViewCreator';

function BS({ changeSearch, searchModel, setView, addNew = () => { }, isAdd = false }) {

    const personModel = new BSModel();


    const clearSubmit = () => {
        document.getElementById('lacBS').value = '';
        document.getElementById('cidBS').value = '';
        document.getElementById('azBS').value = '';
        document.getElementById('addressBS').value = '';
        document.getElementById('descBS').value = '';


        document.getElementById('latBS').value = '';
        document.getElementById('lonBS').value = '';
        document.getElementById('bandBS').value = '';
        document.getElementById('mncBS').value = '';
        document.getElementById('mccBS').value = '';

        personModel.lac = ''
        personModel.cid = ''
        personModel.az = ''
        personModel.address = ''
        personModel.descBS = ''
        personModel.latBS = ''
        personModel.lonBS = ''
        personModel.bandBS = ''
        personModel.mncBS = ''
        personModel.mccBS = ''
        if (searchModel != undefined) {
            searchModel.bs.lac = ''
            searchModel.bs.cid = ''
            searchModel.bs.az = ''
            searchModel.bs.address = ''
            searchModel.bs.descBS = ''
            searchModel.bs.latBS = ''
            searchModel.bs.lonBS = ''
            searchModel.bs.bandBS = ''
            searchModel.bs.mncBS = ''
            searchModel.bs.mccBS = ''
        }
    }

    const addSubmit = () => {
        if (personModel.lac == undefined || personModel.lac == ''){
              showError('LAC не може бути пустим')
              return;
            }

            if (personModel.cid == undefined || personModel.cid == ''){
              showError('CID не може бути пустим')
              return;
            }

            if (personModel.latBS == undefined || personModel.latBS == ''){
              showError('Координати не можуть бути пустими')
              return;
            }

            if (personModel.lonBS == undefined || personModel.lonBS == ''){
              showError('Координати не можуть бути пустими')
              return;
            }

            if (personModel.az == undefined || personModel.az == ''){
              showError('Азимут не може бути пустим')
              return;
            }

        Swal.fire({
            title: 'Ви дійсно бажаєте створити новий запис',
            //text: "Оновити інформацію?",
            icon: 'question',
            html:
                '',
            showDenyButton: false,
            showCancelButton: true,
            confirmButtonText: 'Створити',
            denyButtonText: 'Оновити',

            background: '#2B2B2B',
            color: '#FFF'
        }).then((result) => {
            addNewBS()
        })
    }


    const addNewBS = () => {
        var path = ip + '/api/bs/add';
        personModel.searchModel = new SearchModel()
        var bd = encryptAes(JSON.stringify(personModel))
        const requestOptions = {
            headers: {
                'Content-Type': 'Content-type: text/html'
            },
            credentials: 'include',
            uri: path,
            encoding: 'latin1',
            body: bd,
            method: 'POST'
        };
        fetch(path, requestOptions)
            .then()
            .then(response => { return response.arrayBuffer() })
            .then((buffer) => {
                const decoder = new TextDecoder('windows-1251'); // Декодуємо у CP1251
                const text = decoder.decode(buffer);
                try {
                    var result = JSON.parse(text);
                    showError(result.msg)


                } catch (error) {
                    const decryptedText = decryptAes(text);
                    var result = JSON.parse(decryptedText);
                    storeKey('test_data', result.key);
                    if (isAdd) {
                        addNew(result.data, 20011)
                        clearSubmit()
                    } else {
                        window.open("/edit/bs?id=" + result.data, "_self")
                    }
                }
            })
    }

    const sendBSFullScreen = (id) => {
        window.open("/bs?id=" + id)
    }

    const sendBS = (id) => {
        var path = ip + '/api/bs/id';
        var bd = encryptAes(id)
        const requestOptions = {
            headers: {
                'Content-Type': 'Content-type: text/html; charset=win1251'
            },
            credentials: 'include',
            uri: path,
            encoding: 'latin1',
            body: bd,
            method: 'POST'
        };
        fetch(path, requestOptions)
            .then()
            .then(response => { return response.arrayBuffer() })
            .then((buffer) => {
                const decoder = new TextDecoder('windows-1251'); // Декодуємо у CP1251
                const text = decoder.decode(buffer);
                try {
                    var result = JSON.parse(text);
                    showError(result.msg)

                } catch (error) {
                    const decryptedText = decryptAes(text);
                    var result = JSON.parse(decryptedText);
                    storeKey('test_data', result.key);

                    var zz = []

                    var addr = result.data

                    zz.push(createBS(addr))


                    setView(zz)
                }
            })
    }


    const handleSubmit = (e) => {
        sendSearch();
        e.preventDefault();
    }

    const sendSearch = () => {
        var path = ip + '/api/bs/search';
        personModel.searchModel = new SearchModel()
        var bd = encryptAes(JSON.stringify(personModel))
        const requestOptions = {
            headers: {
                'Content-Type': 'Content-type: text/html'
            },
            credentials: 'include',
            uri: path,
            encoding: 'latin1',
            body: bd,
            method: 'POST'
        };
        fetch(path, requestOptions)
            .then()
            .then(response => { return response.arrayBuffer() })
            .then((buffer) => {
                const decoder = new TextDecoder('windows-1251'); // Декодуємо у CP1251
                const text = decoder.decode(buffer);
                try {
                    var result = JSON.parse(text);
                    showError(result.msg)

                } catch (error) {
                    const decryptedText = decryptAes(text);
                    var result = JSON.parse(decryptedText);
                    storeKey('test_data', result.key);

                    var zz = []

                    for (let index = 0; index < result.data.length; index++) {
                        var z = document.createElement('div'); // is a node
                        var pers = result.data[index]
                        var i = pers.id
                        z.className = "listItem"
                        z.innerHTML = "<p align=\"left\">LAC: " + pers.lac + " CID: " + pers.cid + "<br>Азимут: " + pers.az + "°<br>" + pers.address;
                        if (pers.mnc == 1 && pers.mcc == 255) {
                            z.innerHTML += "Оператор: Водафон"
                        }
                        if (pers.mnc == 3 && pers.mcc == 255) {
                            z.innerHTML += "Оператор: Київстар"
                        }
                        if (pers.mnc == 6 && pers.mcc == 255) {
                            z.innerHTML += "Оператор: Lifecell"
                        }
                        z.style.display = "block";
                        const cl = i => () => {
                            sendBS(i)
                        }
                        const dblcl = i => () => {
                            sendBSFullScreen(i)
                        }
                        //z.onclick = cl(pers.id)
                        z.ondblclick = dblcl(pers.id)
                        var per = new BSModel()
                        per.id = pers.id
                        z.value = per
                        zz.push(z);
                    }
                    changeSearch(zz)
                }
            })
    }

    const handleKeyPress = (event) => {
        event = event || window.event;
        if (event.key === 'Tab') {
            closeAllHelp();
        }
        if (event.key === 'Enter') {
            closeAllHelp();
        }
        if (event.key === 'Escape') {
            closeAllHelp();
        }
    }
    const closeAllHelp = () => {
        var a = document.getElementsByClassName("list");
        for (let index = 0; index < a.length; index++) {
            a[index].innerHTML = "";
        }
    }
    const changedfield = (id) => {
        var input = document.getElementById(id)
        if (input != null) {
            if (input.value.length > 0) {
                document.getElementById(id + "List").innerHTML = "";
                sendHelp(input.value, id);
            } else {
                document.getElementById(id + "List").innerHTML = "";
            }
        }
    }

    const sendHelp = (value, id) => {
        var path = ip + '/api/help/';
        var bd = encryptAes(JSON.stringify({
            "value": value,
            "type": id
        }))
        const requestOptions = {
            headers: {
                'Content-Type': 'Content-type: text/html; charset=win1251'
            },
            credentials: 'include',
            uri: path,
            encoding: 'latin1',
            body: bd,
            method: 'POST'
        };
        fetch(path, requestOptions)
            .then()
            .then(response => { return response.arrayBuffer() })
            .then((buffer) => {
                const decoder = new TextDecoder('windows-1251'); // Декодуємо у CP1251
                const text = decoder.decode(buffer);
                try {
                    var result = JSON.parse(text);
                    showError(result.msg)

                } catch (error) {
                    const decryptedText = decryptAes(text);
                    var result = JSON.parse(decryptedText);
                    var l = result.data.list;
                    for (let index = 0; index < l.length; index++) {
                        var z = document.createElement('div'); // is a node
                        z.className = "listItem"
                        z.innerHTML = l[index];
                        z.style.display = "block";
                        z.href = "#";
                        z.onclick = () => {

                            document.getElementById(id).value = l[index]
                            document.getElementById(id + "List").innerHTML = "";


                            if (id == 'lacBS') {

                                personModel.lac = l[index]

                            }
                            if (id == 'cidBS') {
                                personModel.cid = l[index]
                            }
                            if (id == 'azBS') {
                                personModel.az = l[index]
                            }
                            if (id == 'addressBS') {
                                personModel.address = l[index]
                            }
                            if (id == 'descBS') {
                                personModel.descBS = l[index]
                            }

                            if (id == 'mccBS') {
                                personModel.mccBS = l[index]
                            }

                            if (id == 'mncBS') {
                                personModel.mncBS = l[index]
                            }

                            if (id == 'bandBS') {
                                personModel.bandBS = l[index]
                            }

                            if (id == 'lonBS') {
                                personModel.lonBS = l[index]
                            }

                            if (id == 'latBS') {
                                personModel.latBS = l[index]
                            }
                        }
                        document.getElementById(id + "List").appendChild(z);

                    }
                }
            })








    }



    const lacchange = () => {
        personModel.lac = document.getElementById('lacBS').value
        changedfield('lacBS');
    }

    const cidchange = () => {
        personModel.cid = document.getElementById('cidBS').value
        changedfield('cidBS');
    }

    const azchange = () => {
        personModel.az = document.getElementById('azBS').value
        changedfield('azBS');
    }

    const addresschange = () => {
        personModel.address = document.getElementById('addressBS').value
        changedfield('addressBS');
    }

    const mccchange = () => {
        personModel.mccBS = document.getElementById('mccBS').value
        personModel.mcc = document.getElementById('mccBS').value
        changedfield('mccBS');
    }

    const mncchange = () => {
        personModel.mncBS = document.getElementById('mncBS').value
        personModel.mnc = document.getElementById('mncBS').value
        changedfield('mncBS');
    }

    const bandchange = () => {
        personModel.bandBS = document.getElementById('bandBS').value
        personModel.band = document.getElementById('bandBS').value
        changedfield('bandBS');
    }

    const lonchange = () => {
        personModel.lonBS = document.getElementById('lonBS').value
        personModel.lon = document.getElementById('lonBS').value
        changedfield('lonBS');
    }

    const latchange = () => {
        personModel.latBS = document.getElementById('latBS').value
        personModel.lat = document.getElementById('latBS').value
        changedfield('latBS');
    }

    const descchange = () => {
        personModel.descBS = document.getElementById('descBS').value
        changedfield('descBS');
    }


    const handleFocus = (event) => {
        closeAllHelp()
    };

    return (
        <div>
            <button id="clear-button-bs" className="clear-button-right" onClick={clearSubmit}>Очистити
            </button>
            <button id="add-button-bs" className="add-button-right" onClick={addSubmit}>Додати
            </button>
            <form onSubmit={handleSubmit} className="form">
                <input id="input-button-bs" className="input-button-right" type="submit" value="Пошук" />




                <div id="descBSDrop" className="dropdown-content" onKeyDown={handleKeyPress}>
                    <input id="descBS" className="input-text" tabIndex="10" name="login" type="text" onChange={descchange} placeholder="Опис" autoComplete="off" onKeyDown={handleKeyPress} onFocus={handleFocus} />
                    <div id="descBSList" className="list" />
                </div>

                <div id="mncBSDrop" className="dropdown-content" onKeyDown={handleKeyPress}>
                    <input id="mncBS" className="input-text" tabIndex="9" name="login" type="text" onChange={mncchange} placeholder="Код оператора" autoComplete="off" onKeyDown={handleKeyPress} onFocus={handleFocus} />
                    <div id="mncBSList" className="list" />
                </div>

                <div id="mccBSDrop" className="dropdown-content" onKeyDown={handleKeyPress}>
                    <input id="mccBS" className="input-text" tabIndex="8" name="login" type="text" onChange={mccchange} placeholder="Код країни" autoComplete="off" onKeyDown={handleKeyPress} onFocus={handleFocus} />
                    <div id="mccBSList" className="list" />
                </div>

                

                <div id="bandBSDrop" className="dropdown-content" onKeyDown={handleKeyPress}>
                    <input id="bandBS" className="input-text" tabIndex="7" name="login" type="text" onChange={bandchange} placeholder="Потужність" autoComplete="off" onKeyDown={handleKeyPress} onFocus={handleFocus} />
                    <div id="bandBSList" className="list" />
                </div>

                <div id="lonBSDrop" className="dropdown-content" onKeyDown={handleKeyPress}>
                    <input id="lonBS" className="input-text" tabIndex="6" name="login" type="text" onChange={lonchange} placeholder="Довгота" autoComplete="off" onKeyDown={handleKeyPress} onFocus={handleFocus} />
                    <div id="lonBSList" className="list" />
                </div>

                <div id="latBSDrop" className="dropdown-content" onKeyDown={handleKeyPress}>
                    <input id="latBS" className="input-text" tabIndex="5" name="login" type="text" onChange={latchange} placeholder="Широта" autoComplete="off" onKeyDown={handleKeyPress} onFocus={handleFocus} />
                    <div id="latBSList" className="list" />
                </div>


                <div id="addressBSDrop" className="dropdown-content" onKeyDown={handleKeyPress}>
                    <input id="addressBS" className="input-text" tabIndex="4" name="login" type="text" onChange={addresschange} placeholder="Адреса" autoComplete="off" onKeyDown={handleKeyPress} onFocus={handleFocus} />
                    <div id="addressBSList" className="list" />
                </div>

                <div id="azBSDrop" className="dropdown-content" onKeyDown={handleKeyPress}>
                    <input id="azBS" className="input-text" tabIndex="3" name="login" type="text" onChange={azchange} placeholder="Азимут" autoComplete="off" onKeyDown={handleKeyPress} onFocus={handleFocus} />
                    <div id="azBSList" className="list" />
                </div>

                <div id="cidBSDrop" className="dropdown-content" onKeyDown={handleKeyPress}>
                    <input id="cidBS" className="input-text" tabIndex="2" name="login" type="text" onChange={cidchange} placeholder="Cell ID (CI, CID)" autoComplete="off" onKeyDown={handleKeyPress} onFocus={handleFocus} />
                    <div id="cidBSList" className="list" />
                </div>

                <div id="lacBSDrop" className="dropdown-content" onKeyDown={handleKeyPress}>
                    <input id="lacBS" className="input-text" tabIndex="1" name="login" type="text" onChange={lacchange} placeholder="LAC" autoComplete="off" onKeyDown={handleKeyPress} onFocus={handleFocus} />
                    <div id="lacBSList" className="list" />
                </div>

            </form>
        </div>
    );
}

export default BS;